import { render, staticRenderFns } from "./RecoverPassComponent.vue?vue&type=template&id=43198cb3&scoped=true&"
import script from "./RecoverPassComponent.vue?vue&type=script&lang=ts&"
export * from "./RecoverPassComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RecoverPassComponent.vue?vue&type=style&index=0&id=43198cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43198cb3",
  null
  
)

export default component.exports